import React from 'react';

import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Paper from '@mui/material/Paper';
import Slide from '@mui/material/Slide';
import FormControlLabel from '@mui/material/FormControlLabel';

import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import SvgIcon from "@mui/material/SvgIcon";
import Icon from "@mui/material/Icon";
import Stack from '@mui/material/Stack';

import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

// import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import TextField from '@mui/material/TextField';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';

import RemoveCircleOutlinedIcon from '@mui/icons-material/RemoveCircleOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';

import InputAdornment from '@mui/material/InputAdornment';

import Divider from '@mui/material/Divider';

import { NumericFormat } from 'react-number-format';

import NumberInput from "./NumberInput.js";

import ScoreDisplayer from "../ScoreDisplayer.js"

import settingSystem from "../SettingSystem.js"
import SheetMusicPlayer from './SheetMusicPlayer.js';

import TextManager from '../TextManager';

// import Switch from '@mui/material/Switch';

const DefaultTempo = 120;

export default class PlaybackSettingsPage extends React.Component {

	state = {
		tempo: DefaultTempo,
		transpose: 0,
	}
	
	lastSuccessfulInputs = {
		tempo: this.state.tempo,
		transpose: this.state.transpose,
	}

	updateMidiOutputList = () =>{
		this.forceUpdate();
	}
	
	tempTranspose = null;

	render() {
		const createInstrumentOption = (channelInfo, index) => { 
			return (
				<ListItem key={channelInfo.id}>
					
						<Stack direction="row" spacing={1} alignItems="center" sx={{
							marginRight:"auto",
							maxWidth:"50%",
						}}>
							<ListItemText primary={index} />
							<Switch  edge="end" checked={!channelInfo.mute} onChange={ event => {
								SheetMusicPlayer.singleton.setChannelMute(channelInfo, !event.target.checked);
								this.forceUpdate();
							}}/>
						
						</Stack>

						<Select
							labelId="demo-simple-select-label"
							id="demo-simple-select"
							value={channelInfo.instrument}
							onChange={ event => {
								SheetMusicPlayer.singleton.setInstrument(channelInfo, event.target.value)
								this.forceUpdate();
							}}

							sx={{height:50}}
						>
							{SheetMusicPlayer.singleton.state.avaliableInstruments.map((inst) => 
								<MenuItem key={inst.id} value={inst.id}>{TextManager.getInstrumentNameText(inst.id)}</MenuItem>
							)}
						</Select>
					
				</ListItem>
			)
		}

		const createInstrumentOptions = () => {
			// const optionRows = [];
			// const instruments = ScoreDisplayer.singleton.osmd.Sheet.Instruments;

			// for (const [instrumentIdx, instrument] of instruments.entries()) {
			// 	optionRows.push(createInstrumentOption(instrumentIdx+1));
			// }

			// return optionRows;

			const optionRows = [];
			let i = 0;
			for (const channelInfo of SheetMusicPlayer.singleton.state.channels.filter(channel => channel.haveNotes)) {
				i++;
				optionRows.push(createInstrumentOption(channelInfo, i));
			}
			return optionRows;
		}
		

		return (
		      
			<div className="PopupPage">
				{/*<CloseIcon sx={{float:"right", left:"100px"}}/>*/}
				
				<div className="PageTitle">{TextManager.getText("playback")}</div>
				
				<List className="PageList">
				  <ListItem>
					<ListItemText primary={TextManager.getText("metronome")} />
					<Stack direction="row" spacing={1} alignItems="center">
						<Switch edge="end" checked={settingSystem.getSetting("useMetronome")} onChange={(e)=>settingSystem.setSetting("useMetronome", e.target.checked, this)}/>
					</Stack>
				  </ListItem>
				  
				  <ListItem>
					<ListItemText primary={TextManager.getText("tempo")} />
					<NumberInput suffix="BPM" step={1} min={10} max={500} width="180px"
						defaultValue={settingSystem.getSetting("displayTempo")}
						onCommit={(v)=>{
							settingSystem.setSetting("displayTempo", v, this);
							settingSystem.setSetting("playerTempo", v, this);
						}}
					/>
					
				  </ListItem>
				  
				  <ListItem>
					<ListItemText primary={TextManager.getText("transpose")} />
					<NumberInput step={1} min={-12} max={12} width="120px"
						defaultValue={settingSystem.getSetting("displayTranspose")}
						onCommit={(v) => {
							this.tempTranspose = v;
						}}
					/>
					
				  </ListItem>

				  <ListItem>
					<ListItemText primary={TextManager.getText("playback_method")} />
					<Select 
						value={SheetMusicPlayer.singleton.state.selectedMidiOutputMethod}
						onChange={ async e => {
							await SheetMusicPlayer.singleton.setMidiOutputMethod(e.target.value)
							this.forceUpdate();
						}} 
					>

						<MenuItem value={SheetMusicPlayer.singleton.WebAudioInternalID}>{TextManager.getText("soundfont_synth")}</MenuItem>
						<MenuItem value={SheetMusicPlayer.singleton.WebMidiInternalID}>{TextManager.getText("midi_device")}</MenuItem>
						<MenuItem value={SheetMusicPlayer.singleton.WebBleMidiInternalID}>{TextManager.getText("bluetooth_midi")}</MenuItem>
					</Select>
				</ListItem>

				{
					SheetMusicPlayer.singleton.state.selectedMidiOutputMethod === SheetMusicPlayer.singleton.WebMidiInternalID ?
						<ListItem>
							<ListItemText primary={TextManager.getText("midi_device")} />
								<Select
									value={ SheetMusicPlayer.singleton.avaliableMidiOuputs.length > 0 ? SheetMusicPlayer.singleton.state.selectedMidiOutputId : 'noDevice'}
									onChange={ async e => {
										await SheetMusicPlayer.singleton.setMidiOutputDevice(e.target.value)
										//console.log(SheetMusicPlayer.singleton.state.selectedMidiOutputId)
										this.forceUpdate();
									}}
								>
								{
									SheetMusicPlayer.singleton.avaliableMidiOuputs.length > 0 ?
										SheetMusicPlayer.singleton.avaliableMidiOuputs.map((device) =>	<MenuItem key={device.id} value={device.id}>{device.name}</MenuItem>)
									:
										<MenuItem key={0} value={'noDevice'}>{TextManager.getText("no_midi_devices")}</MenuItem>
								}
							</Select>
						</ListItem>
					: 
						null
				}

				  		
				  
				</List>
				
				<Divider sx={{marginBottom:"0px"}} />
				
				<List className="PageList">
					<ListItem sx={{marginBottom:"-20px"}}>
						<ListItemText primary={TextManager.getText("instruments")} />
					</ListItem>
					{createInstrumentOptions()}
				</List>

				<Stack spacing={2} direction="row" justifyContent="center">
					<Button onClick={
						() => {
							if (this.tempTranspose != null) {
								settingSystem.setSetting("displayTranspose", this.tempTranspose, this);
								settingSystem.setSetting("playerTranspose", this.tempTranspose, this);
							}

							this.props.close();
						}
					} variant="contained">{TextManager.getText("confirm")}</Button>
				</Stack>
			</div>
		);
	}
}
